import React from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'

import styles, { colors, windowTagStyle } from '../../../../styles/global'
import Icon from '../../../../Icon'

export default function OptionButton({
    containerStyle,
    text,
    icon,
    onPress,
    disabled = false,
    buttonStyle,
    iconColor = colors.Text03,
    textStyle,
    onLayout,
    testID,
    pointerEvents,
    focusable,
    accessible,
}) {
    return (
        <TouchableOpacity
            style={[localStyles.tag, buttonStyle, containerStyle, disabled && { opacity: 0.3, pointerEvents: 'none' }]}
            onPress={disabled ? undefined : onPress}
            disabled={disabled}
            activeOpacity={disabled ? 1 : 0.2}
            onLayout={onLayout}
            testID={testID}
            pointerEvents={pointerEvents}
            focusable={focusable}
            accessible={accessible}
        >
            <View style={localStyles.icon}>
                <Icon name={icon} size={16} color={iconColor} />
            </View>
            <Text style={[styles.subtitle2, localStyles.text, windowTagStyle(), textStyle]}>{text}</Text>
        </TouchableOpacity>
    )
}

const localStyles = StyleSheet.create({
    tag: {
        flexDirection: 'row',
        borderRadius: 50,
        justifyContent: 'center',
        alignItems: 'center',
        height: 24,
        alignSelf: 'flex-start',
        borderWidth: 1,
        borderColor: colors.Text03,
        paddingHorizontal: 4,
    },
    text: {
        color: colors.Text03,
        marginLeft: 6,
        marginRight: 4,
    },
    icon: {
        flexDirection: 'row',
        alignSelf: 'center',
    },
})
